export const mapUserData = (user, channel = null, chatClient, message= {}) => {
  if (!user) return null;

  // Defensive: ensure channel and messages exist
  let lastMessage = null;
  if (channel?.state?.messages?.length) {
    lastMessage = channel.state.messages[channel.state.messages.length - 1];
  } else if (message) {
    lastMessage = message;
  }
  return {
    id: user.id,
    name: user.name,
    firstName: user.firstName || (user.name ? user.name.split(" ")[0] : ""),
    lastName: user.lastName || (user.name ? user.name.split(" ")[1] || "" : ""),
    middleName: user.middleName || "",
    role: user.role,
    photo: user.photo,
    organization: user.organization || "N/A",
    clientName: user.eventClientName || "N/A",
    eventName: user.eventName || "N/A",
    team: chatClient?.user?.teams?.[0] || "",
    online: user.online,
    lastMessageDate: lastMessage?.created_at || null,
    lastMessageText: lastMessage?.text || "",
    unreadCount: channel ? (typeof channel.countUnread === 'function' ? channel.countUnread() : 0) : 0,
  };
};